import React from 'react';
import { FiSearch } from 'react-icons/fi';
import { bannerList } from './data';
import './Styles/Banner.scss';

const Banner=()=>{
    return(
        <div className="help-banner">
         <h1>How can we help?</h1>
         <div className="input-group">
             <FiSearch className="icon"/> <input type="text" placeholder="Search in Hostdesign Support" />
         </div>
         <div className="content">

             <p>Try searching for:</p>
             <ul>
                 {bannerList.map((item) =>{
                     return(
                         <li>
                          {item}
                         </li>
                     )
                     })}
             </ul>
         </div>
        </div>
    )
};
export default Banner ;